import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { consultationQKeys } from "@hooks/queries/consultation/queryKeys";
import { followUpQKeys } from "@hooks/queries/followUp/queryKeys";


interface MutationProps {
  consultationId: string;
  formData: FormData;
}

export const useUpdateConsultation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ consultationId, formData }: MutationProps) => {
      return api.patch(`report/${consultationId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: res => {
      // console.log(res.data);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.singleConsultation(res.data._id),
      });
      // Need to invalidate patient queries too, to update the list of consultations
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.patient(res.data.patient_id),
      });
      queryClient.invalidateQueries({
        queryKey: followUpQKeys.all(),
      });
    },

    onError: (res, variables) => {
      console.error("[From Update consultation]", res);
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.singleConsultation(
          variables.consultationId
        ),
      });
      queryClient.invalidateQueries({
        queryKey: consultationQKeys.patient(
          variables.formData.get("patient_id") as string
        ),
      });
    },
  });
};
